import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { TrackState } from '../_models/TrackState';
import { AudioPlayerService } from '../_services/audio-player.service';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css']
})
export class AudioPlayerComponent implements AfterViewInit {

  @ViewChild('player') playerRef;
  player: any;

  constructor(private playerService: AudioPlayerService) {
    playerService.playTrack$.subscribe(url => {
      this.playTrack(url);
    });

    playerService.pauseTrack$.subscribe(() => {
      this.pauseTrack();
    });

    playerService.currentTimeChanged$.subscribe(time => {
      this.seek(time);
    });
  }

  ngAfterViewInit() {
    this.player = this.playerRef.nativeElement;

    this.player?.addEventListener('timeupdate', event => {
      const trackState = new TrackState();
      trackState.currentSrc = event.target.currentSrc;
      trackState.currentTime = event.target.currentTime;
      this.playerService.timeUpdate(trackState);
    });
  }

  seek(time) {
    this.player.currentTime = time;
  }

  playTrack(url) {
    this.player.src = url;
    this.player.play();
  }

  pauseTrack() {
    this.player?.pause();
  }

  playerEnded() {
    this.playerService.trackEnded();
  }
}
